import type { AppDef } from '../../types/window';
import { dispatch, getState, subscribe } from '../../state/store';
import { el } from './dom';

function check(label: string, on: boolean, fn: (v: boolean) => void): HTMLLabelElement {
  const row = document.createElement('label');
  row.className = 'w95-check';
  const box = document.createElement('input');
  box.type = 'checkbox';
  box.checked = on;
  box.addEventListener('change', () => fn(box.checked));
  row.append(box, document.createTextNode(` ${label}`));
  return row;
}

function paint(root: HTMLElement): void {
  const s = getState();
  const wrap = el('div', { className: 'app-stack' });
  wrap.append(
    el('h1', { text: 'Sounds' }),
    el('p', { text: 'Same speaker in the tray. These just give it checkboxes.' }),
    check('Mute everything', s.mute, (on) => dispatch({ type: 'SET_MUTE', mute: on })),
    check('Play interface clicks', s.uiSounds, (on) => dispatch({ type: 'SET_UI_SOUNDS', on })),
    check('Room hum (the dusty speakers)', s.ambientOn, (on) => dispatch({ type: 'SET_AMBIENT', on })),
  );
  root.replaceChildren(wrap);
}

export const soundsApp: AppDef = {
  appId: 'sounds',
  title: 'Sounds',
  icon: 'speaker',
  defaultSize: { w: 380, h: 240 },
  singleton: true,
  mount(root) {
    paint(root);
    const unsub = subscribe((_s, event) => {
      if (
        event.type === 'SET_MUTE' ||
        event.type === 'SET_UI_SOUNDS' ||
        event.type === 'SET_AMBIENT' ||
        event.type === 'TOGGLE_AMBIENT'
      ) {
        paint(root);
      }
    });
    return () => {
      unsub();
      root.replaceChildren();
    };
  },
};
